import { IDownloadFuncionarioDocumentoByIdUseCase } from "../../../presentation/useCases/read/download_funcionario_documento_by_id_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class DownloadFuncionarioDocumentoByIdUseCase implements IDownloadFuncionarioDocumentoByIdUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async downloadFuncionarioDocumentoById(
    idFuncionarioArquivo: number, imageName: string
  ): Promise<void> {
    const blob = await this.repository.downloadFuncionarioDocumentoById(idFuncionarioArquivo);

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click(); 
    
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
